import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';
import { CalculatedFieldEvent } from './types';

export const viewWorkspaceHistory = actionCreator<{
  id: ArdoqId;
  name: string;
}>('[workspace] WORKSPACE_OPTIONS_VIEW_WORKSPACE_HISTORY');

export type RestoreDeletedPayload = { id: ArdoqId; workspaceName: string };

export const restoreDeleted = actionCreator<RestoreDeletedPayload>(
  '[workspace] WORKSPACE_OPTIONS_RESTORE_DELETED_WORKSPACE'
);

export const exportWorkspaceToExcel = actionCreator<{
  workspaceId: ArdoqId;
  filename: string;
}>('[workspace] WORKSPACE_OPTIONS_EXPORT_WORKSPACE_TO_EXCEL');

export const createTemplate = actionCreator<ArdoqId>(
  '[workspace] WORKSPACE_OPTIONS_CREATE_TEMPLATE'
);

export const calculatedFieldEventReceived = actionCreator<CalculatedFieldEvent>(
  '[workspace] WORKSPACE_OPTIONS_CALCULATED_FIELD_EVENT_RECEIVED'
);

export const setCalculatedFieldEvent = actionCreator<CalculatedFieldEvent>(
  '[workspace] WORKSPACE_OPTIONS_SET_CALCULATED_FIELD_EVENT'
);

export const setUserCalculatedFieldEventsAsNotified = actionCreator<ArdoqId>(
  '[workspace] WORKSPACE_OPTIONS_RESET_CALCULATED_FIELD_EVENTS_USER'
);
